import { Card, CardContent } from "@bowfast/ui/components/card";
import { cn } from "@bowfast/ui/lib/utils";
import type { StatCard } from "~/lib/types";

export function StatTile({ label, value, sub, Icon, iconColor, accentClass }: Readonly<StatCard>) {
  return (
    <Card className="group relative overflow-hidden transition-shadow hover:shadow-md">
      <div className={cn("absolute inset-x-0 top-0 h-0.75 rounded-t-xl", accentClass)} />
      <CardContent className="flex items-start gap-3 pb-4 pt-5">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted transition-transform group-hover:scale-110">
          <Icon className={cn("size-4", iconColor)} />
        </div>
        <div className="min-w-0">
          <p className="text-[0.625rem] font-bold uppercase tracking-[0.04em] text-muted-foreground">{label}</p>
          <p className="mt-0.5 font-heading text-xl font-bold tabular-nums leading-none tracking-[-0.02em]">{value}</p>
          <p className="mt-1 text-xs text-muted-foreground">{sub}</p>
        </div>
      </CardContent>
    </Card>
  );
}
